import { Component, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../shared/services/api.service';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';
import { PATTERNS } from '../../../shared/constants/patterns.constants';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrl: './country.component.scss'
})
export class CountryComponent implements OnInit {

  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  apiUrl: any;
  type = 'country';
  pattern = PATTERNS;
  currencies: any;
  duplicateDisplayNameError: string = '';
  duplicateCountryCodeError: string = '';
  checkingDuplicate: boolean = false;
  lastCheckedField: string = '';
  @ViewChild('content') content!: TemplateRef<any>;
  @ViewChild('remittanceWarningModal') remittanceWarningModal!: TemplateRef<any>;
  modalTitle: string = 'New Country';

  columnDefs: ColDef[] = [
      {
      headerName: 'Action',
      field: 'action',
      width: 120,
      cellRenderer: (params: any) => {
        const container = document.createElement('div');
        container.classList.add('d-flex', 'gap-1');

        // Check if params and params.data exist before accessing properties
        if (params && params.data) {
          const editBtn = document.createElement('button');
          editBtn.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
          editBtn.innerHTML = '<i class="bi bi-eye-fill"></i>';
          editBtn.addEventListener('click', () => this.onEdit(params));

          container.appendChild(editBtn);

          // Show dynamic fields button only if isRemittance is true
          if (params.data.isRemittance) {
            const dynamicFieldsBtn = document.createElement('button');
            dynamicFieldsBtn.classList.add('btn', 'btn-sm', 'btn-info', 'active', 'rounded-pill');
            dynamicFieldsBtn.innerHTML = '<i class="bi bi-gear-fill"></i>';
            dynamicFieldsBtn.addEventListener('click', () => this.onDynamicFields(params));
            container.appendChild(dynamicFieldsBtn);


            // Show remittance config button
            const remittanceBtn = document.createElement('button');
            remittanceBtn.classList.add('btn', 'btn-sm', 'btn-secondary', 'active', 'rounded-pill');
            remittanceBtn.innerHTML = '<i class="bi bi-geo-alt-fill"></i>';
            remittanceBtn.addEventListener('click', () => this.onRemittanceConfig(params));
            container.appendChild(remittanceBtn);

          }
        }

        return container;
      },
    },
    {
      headerName: 'Name',
      field: 'displayName',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Country Code',
      field: 'country_code',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Dialing Code',
      field: 'dialingCode',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Currency',
      field: 'currency.name',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
    },
    {
      headerName: "Image",
      field: "icon",
      cellRenderer: (params) => {
        console.log(params)
        if (params.value) { // Check if a value exists
          const img = document.createElement('img');
          img.src = params.value;
          img.style.maxWidth = '100%';
          img.style.maxHeight = '30px';
          img.style.objectFit = 'contain';
          return img;
        }
        return null;
      }
    },
    {
      headerName: 'Remittance',
      field: 'isRemittance',
      editable: false,
      filter: false,
      width: 120,
      valueFormatter: (params: any) => {
        return params.value ? 'Yes' : 'No';
      },
      cellClass: (params: any) => {
        return params.value ? 'text-success' : 'text-muted';
      }
    },
    {
      headerName: 'Origination',
      field: 'isOrigination',
      editable: false,
      filter: false,
      width: 120,
      valueFormatter: (params: any) => {
        return params.value ? 'Yes' : 'No';
      },
      cellClass: (params: any) => {
        return params.value ? 'text-success' : 'text-muted';
      }
    }
  
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };


  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
    private zone: NgZone,
    private router: Router
  ) { }

  ngOnInit(): void {
    const vm = this;
    vm.getCurrencies();
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        vm.apiUrl = '/admin/get-data?type=' + vm.type + '&_page=' + request._page + '&_limit=' + request._limit + '&_sort=displayName&_order=asc';
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            console.log(vm.count);
            console.log(res);
            // Sort country list alphabetically by display name
            const sortedData = res.data.sort((a: any, b: any) => {
              const nameA = a.displayName.toLowerCase();
              const nameB = b.displayName.toLowerCase();
              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;
              return 0;
            });
            params.successCallback(sortedData, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  getCurrencies() {
    const vm = this;
    const type = 'currency'
    const apiUrl = '/admin/get-data?type=' + type + '&_limit=500';
    vm._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error) {
        vm.currencies = res.data.sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  addNew() {
    const vm = this;
    vm.dataObj = {};
    vm.duplicateDisplayNameError = '';
    vm.duplicateCountryCodeError = '';
    vm.modalTitle = 'New Country';
    console.log(vm.content);
    vm.modalRef = vm._modal.open(this.content, { backdrop: 'static', size: 'xl' });
  }

  checkDuplicateCountry(field?: string) {
    const vm = this;
    vm.checkingDuplicate = true;
    vm.duplicateDisplayNameError = '';
    vm.duplicateCountryCodeError = '';
    const checkUrl = `/admin/get-data?type=${vm.type}&displayName=${vm.dataObj.displayName || ''}&country_code=${vm.dataObj.country_code || ''}&_limit=1`;
    vm._api.getData(checkUrl).subscribe({
      next: (res: any) => {
        vm.checkingDuplicate = false;
        if (res && !res.error && res.data && res.data.length > 0) {
          const existing = res.data[0];
          if (!vm.dataObj._id || existing._id !== vm.dataObj._id) {
            if (vm.dataObj.displayName && existing.displayName === vm.dataObj.displayName) {
              vm.duplicateDisplayNameError = 'Country name already exists';
            }
            if (vm.dataObj.country_code && existing.country_code === vm.dataObj.country_code) {
              vm.duplicateCountryCodeError = 'Country code already exists';
            }
          }
        }
      },
      error: () => {
        vm.checkingDuplicate = false;
      }
    });
  }


  onEdit(data: any) {
    const vm = this;
    vm.zone.run(() => {
      vm.dataObj = { ...data.data };
      if (vm.dataObj.currency && vm.dataObj.currency._id) {
        vm.dataObj.currency = vm.dataObj.currency._id;
      }
      // Ensure checkbox fields are explicit booleans so API receives actual true/false
      vm.dataObj.isOrigination = !!vm.dataObj.isOrigination;
      vm.dataObj.isRecipient = !!vm.dataObj.isRecipient;
      vm.dataObj.isRemittance = !!vm.dataObj.isRemittance;
      vm.modalTitle = 'Edit Country';
      vm.modalRef = vm._modal.open(vm.content, { backdrop: 'static', size: 'xl' });
    });
  }

  setContent(c: any) {
    this.content = c;
  }

  onSubmit(flag: any) {
    const vm = this;
    if (vm.duplicateDisplayNameError || vm.duplicateCountryCodeError) {
      alert(vm.duplicateDisplayNameError || vm.duplicateCountryCodeError);
      return;
    }
    vm.dataObj['type'] = vm.type;
    vm.dataObj['id'] = 123;
    console.log(vm.dataObj);
    const apiUrl = vm.dataObj._id ? '/admin/edit-data' : '/admin/new-data';
    vm._api.postData(apiUrl, vm.dataObj).subscribe({
      next: (res: any) => {
        console.log('Success:', res);
        vm.onClose();
        vm.dataObj = {};
        if (vm.gridApi) {
          vm.gridApi.refreshInfiniteCache();
        }
      },
      error: (err: any) => {
        console.log('Error:', err);
        alert(
          err ||
          err?.message ||
          'Something went wrong'
        );
      }
    });
  }

  onDynamicFields(data: any) {
    const vm = this;
    vm.router.navigate(['/app/countries', data.data._id, 'dynamic']);
  }

  onRemittanceChange(event: any) {
    const vm = this;
    if (event.target.checked) {
      vm.modalRef = vm._modal.open(vm.remittanceWarningModal, { backdrop: 'static', size: 'lg' });
    }
  }

  openDynamicFieldsLink() {
    const vm = this;
    const url = `/app/countries/${vm.dataObj._id}/dynamic`;
    window.open(url, '_blank');
  }

  openBillsLink() {
    const vm = this;
    const url = `/app/bills`;
    window.open(url, '_blank');
  }

  onRemittanceConfig(data: any) {
    const vm = this;
    vm.router.navigate(['/app/countries', data.data._id, 'remittance']);
  }

  onClose() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

}